import React from 'react';
import PropTypes from 'prop-types';

const FacetOption = ({ value, label, count, checked, onChange }) => {
	const inputId = `facet-option-${value}`;
	return (
		<li className="facet-option">
			<label className="facet-option__label" htmlFor={inputId}>
				<input
					id={inputId}
					type="checkbox"
					className="facet-option__checkbox"
					checked={checked}
					onChange={() => onChange(value)}
					aria-checked={checked}
				/>
				{label}
				{count != null && <span className="text-muted">{count}</span>}
			</label>
		</li>
	);
};

FacetOption.propTypes = {
	value: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	count: PropTypes.number,
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired
};

export default FacetOption;
